import { z } from 'zod';
import { partnerMatchingLanguageSchema } from '../../partner-management/partnerMatchingLanguage.js';
export const partnerCriteriaSchema = z.object({
    matchingLanguages: z.array(partnerMatchingLanguageSchema),
});
